import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View, Image, Pressable } from 'react-native';
import { BLACK_700, BLACK_900, BLUE_500, Card, DynamicSvg, getTestId, isValidObject, Typography, useBreakpoint } from '@airtel/air-design-system';
import { getHeroLobWidgetStyles } from '../../HeroLobWidgetStyles';
export var PropositionCard = props => {
  var imageUrl = props.imageUrl,
    title = props.title,
    description = props.description,
    _props$resizeMode = props.resizeMode,
    resizeMode = _props$resizeMode === void 0 ? 'cover' : _props$resizeMode,
    id = props.id,
    onCardPressMetaData = props.onCardPressMetaData,
    onUserAction = props.onUserAction,
    testID = props.testID,
    _props$iconName = props.iconName,
    iconName = _props$iconName === void 0 ? 'RightArrowButtonIcon' : _props$iconName;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var widgetStyles = getHeroLobWidgetStyles();
  return _jsx(Card, Object.assign({
    style: widgetStyles.cardContainer,
    showShadow: false
  }, getTestId(testID, "PropositionCard-" + id), {
    children: _jsxs(Pressable, Object.assign({
      onPress: () => {
        isValidObject(onCardPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onCardPressMetaData), {
          item: props
        }));
      },
      style: widgetStyles.cardContainer
    }, {
      children: [_jsxs(View, Object.assign({
        style: widgetStyles.propositionCard
      }, {
        children: [!!imageUrl && _jsx(Image, {
          source: {
            uri: isLargeScreen ? imageUrl.desktop : imageUrl.mobile
          },
          resizeMode: resizeMode,
          style: widgetStyles.imageContainer
        }), _jsx(DynamicSvg, {
          iconName: iconName,
          fontSize: 20,
          color: BLUE_500
        })]
      })), _jsx(Typography, {
        text: title,
        type: "body-para-md-bold",
        color: BLACK_900
      }), _jsx(Typography, {
        text: description,
        type: "body-para-sm",
        numberOfLines: 3,
        color: BLACK_700,
        style: widgetStyles.text
      })]
    }))
  }));
};